import { IProgram } from '@ucheba/store/institutions/programs/types'

export interface IProgramsProps {
  isBanner?: boolean
  programType: number
  linkTarget?: '_blank' | null
  showEducationalInstitutionAddedNotification?: boolean
  items?: IProgram[] | null
}

export interface IProgramsItemProps extends IProgram {
  isDivider?: boolean
  linkTarget?: '_blank' | null
}

export enum ETextColorCheap {
  yellow = 'orange',
  lime = 'emerald',
  rose = 'red',
}
